import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "container"]

  add() {
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, Date.now())
    this.containerTarget.insertAdjacentHTML("beforeend", content)

    const lastItem = this.containerTarget.lastElementChild
    lastItem.dispatchEvent(new CustomEvent("nested:added", { bubbles: true }))
  }

  remove(event) {
    event.preventDefault()
    event.target.closest(".nested-fields").remove()
  }
}
